module.exports = __webpack_public_path__ + "static/media/tree-outlined.1732ab00.png";